import React from 'react';
import { PapiEditorText } from '@wix/da-papi-types';

import GallectionTiptapEditor from '@wix/da-editor-tiptap/pkg/components/Editor/presets/Gallection';
import { EditorApi } from '@wix/da-editor-tiptap/pkg/components/Editor/types';
import { UseEditorOptions } from '@wix/da-editor-tiptap/pkg/hooks/useEditor';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { EditorContextProviderWrapper } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import useEditorNg from '../DaEditorNg/hooks/useEditorNg';
import EditorCommon from '../DaEditorNg/EditorCommon';

export type EditorTiptapContentReadyHandler = (api: EditorApi) => void;

export interface Props {
  className?: string;
  initialContent?: PapiEditorText;
  placeholder?: string;
  onInitialContentReady?: EditorTiptapContentReadyHandler;
  onChange?: UseEditorOptions['onEditorChange'];
  compact?: boolean;
}

const GallectionEditor: React.FC<Props> = ({
  onChange,
  onInitialContentReady,
  initialContent,
  compact,
}) => {
  const { editorProps, editorSharedProps, editorCommonProps } = useEditorNg({
    onEditorChange: onChange,
    onEditorReady: (api: EditorApi) => {
      onInitialContentReady && onInitialContentReady(api);
    },
  });
  return (
    <EditorContextProviderWrapper>
      <EditorCommon {...editorCommonProps} />
      <GallectionTiptapEditor
        cookieType={MeasuredCookieType.GALLECTION_FOLDER}
        {...editorSharedProps}
        {...editorProps}
        initialContent={initialContent}
        compact={compact}
      ></GallectionTiptapEditor>
    </EditorContextProviderWrapper>
  );
};
GallectionEditor.displayName = 'GallectionEditor';

export default GallectionEditor;
